import api from '@/apis'
import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import type { ServiceAreaAvailability } from '@/types/serviceArea'

export interface GetServiceAreaAvailabilityParams {
  /** 검증할 주소 (한글 풀 주소 — Daum jibunAddress 또는 Airbridge `address` query) */
  address: string
}

/**
 * 서비스 지역 여부 검증 — 1차 검증 (주소 클릭 직후 자동 호출).
 *
 * Host: 기본 mobile-api (`VITE_API_BASE_URL`) — service-area / region API 와 동일 호스트.
 * Path: `/service-area/availability?address=...`
 *
 * 응답: 200 + { address, isAvailable, waitingCount }
 *  - isAvailable=true → 수거 가능 결과 화면
 *  - isAvailable=false → 수거 불가능 결과 화면 (오픈 요청)
 *
 * user-context 에러(미납 E422201 / 이미 신청 E409200)는 1차에 안 옴 — 2차 검증
 * (`/orders/availability`) 에서 차단. 이 API 는 순수 지역 여부만 검증.
 *
 * 인증: Bearer (회원만 호출 가능) — 인터셉터가 tokenStore 에서 자동 주입
 */
export const apiGetServiceAreaAvailability = async ({
  address,
}: GetServiceAreaAvailabilityParams): Promise<ServiceAreaAvailability> => {
  if (IS_MOCK) {
    await mockDelay()
    // mock: 주소에 '연천' / '하하동' 등 키워드 포함 시 미오픈 지역, 그 외 가능
    const isAvailable = !/연천|하하동|미오픈/.test(address)
    return {
      address,
      isAvailable,
      waitingCount: isAvailable ? null : Math.floor(Math.random() * 50),
    }
  }
  return await api.get<ServiceAreaAvailability>('/service-area/availability', {
    params: { address },
  })
}
